<template>
  <b-modal
    id="MantenimientoContratoModal"
    :hide-footer="true"
    size="xl"
    title="Mantenimiento de Contrato"
    @shown="onShown"
  >
    <form v-promise-btn="{ action: 'submit' }" @submit.prevent="submit">
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Mantenimiento de Contrato</h4>
          </div>
        </template>
        <div class="container">
          <div class="row">
            <div class="col-12 form-group form-group-md">
              <div class="form-group">
                <label for="nombre" class="label">Nombre de cliente</label>
                <input
                  type="text"
                  class="form-control text-center"
                  disabled
                  name="nombre"
                  id="nombre"
                  v-model="nombreCliente"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 form-group form-group-md">
              <div class="form-group">
                <label for="avl" class="label">Avl</label>
                <input
                  type="text"
                  class="form-control text-center"
                  disabled
                  name="Avl"
                  id="avl"
                  v-model="idAVL"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 form-group form-group-md">
              <div class="form-group">
                <label for="patente" class="label">Patente de vehiculo</label>
                <input
                  type="text"
                  class="form-control text-center"
                  disabled
                  name="patente"
                  id="patente"
                  v-model="patente"
                />
              </div>
            </div>
          </div>
          <div v-if="this.idContratoMantenimiento" class="row">
            <div class="col">
              <p class="alert alert-warning">
                Éste contrato ya esta en mantenimiento
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 form-group form-group-sm">
              <label for="fechaInicio">Fecha Inicio</label>
              <input
                id="fechaInicio"
                v-model="fechaInicio"
                class="form-control text-center"
                type="date"
              />
            </div>

            <div
              :style="`${!this.indefinido ? 'opacity:1' : 'opacity:0'}`"
              class="col-12 col-md-4 form-group form-group-sm"
            >
              <label for="fechaFin">Fecha Fin</label>
              <input
                id="fechaFin"
                v-model="fechaFin"
                class="form-control text-center"
                type="date"
              />
            </div>
            <div
              class="col-12 col-md-3 form-group form-group-sm d-flex align-items-end"
            >
              <label class="label" for="indefinido">
                <input
                  id="indefinido"
                  v-model="indefinido"
                  class="form-check-inline"
                  type="checkbox"
                />
                por tiempo indefinido
              </label>
            </div>
            <div class="col-12 form-group form-group-sm">
              <label for="porcentajeDescuento">Porcentaje de Descuento</label>
              <input
                id="porcentajeDescuento"
                v-model="porcentajeDescuento"
                class="form-control text-center"
                max="100"
                min="0"
                type="number"
              />
            </div>

            <div class="col-12 form-group form-group-sm">
              <label class="label" for="notas"> Notas </label>
              <textarea
                id="notas"
                v-model="notas"
                class="form-control text-center"
                cols="30"
                name="notas"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  class="btn btn-secondary"
                  type="button"
                  @click="cancelarModal"
                >
                  Cancelar
                </button>
                <button class="btn btn-primary" type="submit">Aceptar</button>
              </div>
            </div>
          </div>
        </div>
      </card-item>
    </form>
  </b-modal>
</template>

<script>
import { get, isNull } from "lodash-es";
import axios from "axios";

export default {
  name: "MantenimientoContratoModal",
  methods: {
    onShown() {
      this.isDirty = false;
      if (isNull(this.porcentajeDescuento)) {
        this.porcentajeDescuento = 50;
      }
      if (!this.idContratoMantenimiento) {
        this.indefinido = true;
      }
    },
    async submit() {
      let FechaFin;
      if (!this.indefinido) {
        FechaFin = await get(
          this.$store.state.Contratos,
          "ModificarContrato.fechaFin",
          null,
        );
        if (!FechaFin) {
          await this.$msgBoxOk("Por favor, complete fecha fin .");
          return;
        }
      }
      const idContrato = this.$route.params.id_contrato;
      this.isDirty = true;

      const resp = await axios.post("/execute", {
        method: "CLI.MantenimientoDeContrato",
        parameters: [
          { name: "id_contrato", value: idContrato },
          {
            name: "fecha_inicio",
            value: this.fechaInicio,
          },
          {
            name: "fecha_fin",
            value: this.indefinido ? null : FechaFin,
          },
          { name: "notas", value: this.notas },
          { name: "porcentaje_descuento", value: this.porcentajeDescuento },
        ],
      });
      if (resp.data.ok) {
        this.$msgBoxOk("Éxito!").then(() => {
          this.cancelarModal();
          this.$emit("mantenimiento");
        });
      } else {
        this.$msgBoxOk(resp.message);
      }
      this.isDirty = false;
    },
    cancelarModal() {
      this.$bvModal.hide("MantenimientoContratoModal");
    },
  },
  computed: {
    idContratoMantenimiento: {
      get() {
        return this.$store.state.Contratos.ModificarContrato
          .idContratoMantenimiento;
      },
    },
    nombreCliente() {
      return get(this.$store.state.Contratos, "nombreWeb", "");
    },
    idAVL() {
      return get(this.$store.state.Contratos.ModificarContrato, "avl", "S/N");
    },
    patente() {
      return get(
        this.$store.state.Contratos.ModificarContrato,
        "patenteAnterior",
        "sin patente",
      );
    },
    fechaInicio: {
      get() {
        if (this.idContratoMantenimiento) {
          const fechaDeInicio =
            this.$store.state.Contratos.ModificarContrato.fechaInicio;
          if (fechaDeInicio) {
            return this.$moment(fechaDeInicio).format("YYYY-MM-DD");
          }
          return "";
        } else {
          return this.$moment().format("YYYY-MM-DD");
        }
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setFechaInicio", val);
      },
    },
    fechaFin: {
      get() {
        if (this.idContratoMantenimiento) {
          const fecha = this.$store.state.Contratos.ModificarContrato.fechaFin;
          return this.$moment(fecha).format("YYYY-MM-DD");
        } else {
          return null;
        }
      },
      set(val) {
        if (val) {
          const FechaFin = this.$moment(val).format("YYYY-MM-DD");
          this.$store.commit(
            "Contratos/ModificarContrato/setFechaFin",
            FechaFin,
          );
        }
      },
    },
    porcentajeDescuento: {
      get() {
        return this.$store.state.Contratos.ModificarContrato
          .porcentajeDescuento;
      },
      set(val) {
        this.$store.commit(
          "Contratos/ModificarContrato/setPorcentajeDescuento",
          val,
        );
      },
    },
    notas: {
      get() {
        if (this.idContratoMantenimiento) {
          const Notas = this.$store.state.Contratos.ModificarContrato.notas;
          return Notas;
        }
        return this.$store.state.Contratos.ModificarContrato.notas;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setNotas", val);
      },
    },
  },
  watch: {},
  data: () => ({
    isDirty: false,
    indefinido: true,
  }),
};
</script>
